'use client';

import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('popstate', onChange);
  return () => window.removeEventListener('popstate', onChange);
}

/**
 * Значение query-параметра на статической странице без перевода её в dynamic
 * (useSearchParams потребовал бы Suspense-границу). На SSR и до гидрации null.
 * Паттерн как в components/site/LaunchCountdown.tsx.
 */
export function useQueryParam(name: string): string | null {
  return useSyncExternalStore(
    subscribe,
    () => new URLSearchParams(window.location.search).get(name),
    () => null,
  );
}
